/**
 * @returns { string } This includes the ID of the user and the type of ID, if available.
 *
 * The DoneDeal user ID is prioritised with the Keycloak user ID used as a fallback.
 */
export const identifyUser = (args: {
  donedealUserId: string | null;
  keycloakUserId: string | null;
}): string => {
  const { keycloakUserId, donedealUserId } = args;

  const fallbackUserId = keycloakUserId
    ? `Keycloak user ${keycloakUserId}`
    : 'unknown user';

  const userId = donedealUserId
    ? `DoneDeal user ${donedealUserId}`
    : fallbackUserId;

  return userId;
};
